import Vue from "vue";
import Router from "vue-router";
import Home from "../views/Home";
import Kunstwerke from "../views/Kunstwerke.vue";
import TexteStart from "../views/texte/Start.vue";
import TexteModus from "../views/texte/TexteModus.vue";
import MedienOverview from "../views/texte/MedienOverview.vue";
import Merzwerbe from "../views/MerzWerbe.vue";
import Personen from "../views/Personen.vue";
import OrteUndWege from "../views/OrteUndWege.vue";
import Bibliographie from "../views/Bibliographie.vue";
import Suche from "../views/Suche.vue";
import Hilfe from "../views/Hilfe.vue";
import Projektinfo from "../views/Projektinfo.vue";
import Beteiligte from "../views/Beteiligte.vue";
import Foerderer from "../views/Foerderer.vue";
import Kontakt from "../views/Kontakt.vue";
import Datenschutz from "../views/Datenschutz.vue";
import Impressum from "../views/Impressum.vue";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: "/",
      name: "home",
      component: Home
    },
    {
      path: "/kunstwerke",
      name: "kunstwerke",
      component: Kunstwerke
    },
    {
      path: "/texte/merzhefte",
      name: "texte",
      component: TexteStart
    },
    {
      path: "/texte/ursonate",
      name: "medien-overview",
      component: MedienOverview
    },
    {
      path: "/texte/merzhefte/:modus",
      name: "texte-modus",
      component: TexteModus
    },
    {
      path: "/merzwerbe/:modus?",
      name: "werbe-modus",
      component: Merzwerbe
    },
    {
      path: "/personen",
      name: "personen",
      component: Personen
    },
    {
      path: "/orteundwege",
      name: "orteundwege",
      component: OrteUndWege
    },
    {
      path: "/bibliographie/:keyitem?",
      name: "bibliographie",
      component: Bibliographie
    },
    {
      path: "/suche",
      name: "suche",
      component: Suche
    },
    {
      path: "/hilfe",
      name: "hilfe",
      component: Hilfe

    },
    {
      path: "/projektinfo",
      name: "projektinfo",
      component: Projektinfo
    },
    {
      path: "/beteiligte",
      name: "beteiligte",
      component: Beteiligte
    },
    {
      path: "/foerderer",
      name: "foerderer",
      component: Foerderer
    },
    {
      path: "/kontakt",
      name: "kontakt",
      component: Kontakt
    },
    {
      path: "/datenschutz",
      name: "datenschutz",
      component: Datenschutz
    },
    {
      path: "/impressum",
      name: "impressum",
      component: Impressum
    }]
});



// WEBPACK FOOTER //
// ./src/router/index.js